/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationResponseBaseResponse as ModelsV4ApplicationApplicationResponseBaseResponse } from '../models/Models/v4/Application/application-response-base-response';
import { ApplicationUpdatePersonalResponseBaseResponse as ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse } from '../models/Models/v4/Application/Public/application-update-personal-response-base-response';
import { BooleanBaseResponse as SystemBooleanBaseResponse } from '../models/System/boolean-base-response';
import { v4PublicApplicationPersonalApplicationIdPut$Json } from '../fn/public-personal-application/v-4-public-application-personal-application-id-put-json';
import { V4PublicApplicationPersonalApplicationIdPut$Json$Params } from '../fn/public-personal-application/v-4-public-application-personal-application-id-put-json';
import { v4PublicApplicationPersonalApplicationIdPut$Plain } from '../fn/public-personal-application/v-4-public-application-personal-application-id-put-plain';
import { V4PublicApplicationPersonalApplicationIdPut$Plain$Params } from '../fn/public-personal-application/v-4-public-application-personal-application-id-put-plain';
import { v4PublicApplicationPersonalPingGet$Json } from '../fn/public-personal-application/v-4-public-application-personal-ping-get-json';
import { V4PublicApplicationPersonalPingGet$Json$Params } from '../fn/public-personal-application/v-4-public-application-personal-ping-get-json';
import { v4PublicApplicationPersonalPingGet$Plain } from '../fn/public-personal-application/v-4-public-application-personal-ping-get-plain';
import { V4PublicApplicationPersonalPingGet$Plain$Params } from '../fn/public-personal-application/v-4-public-application-personal-ping-get-plain';
import { v4PublicApplicationPersonalPingGet$Xml } from '../fn/public-personal-application/v-4-public-application-personal-ping-get-xml';
import { V4PublicApplicationPersonalPingGet$Xml$Params } from '../fn/public-personal-application/v-4-public-application-personal-ping-get-xml';
import { v4PublicApplicationPersonalPost$Json$Json } from '../fn/public-personal-application/v-4-public-application-personal-post-json-json';
import { V4PublicApplicationPersonalPost$Json$Json$Params } from '../fn/public-personal-application/v-4-public-application-personal-post-json-json';
import { v4PublicApplicationPersonalPost$Json$Plain } from '../fn/public-personal-application/v-4-public-application-personal-post-json-plain';
import { V4PublicApplicationPersonalPost$Json$Plain$Params } from '../fn/public-personal-application/v-4-public-application-personal-post-json-plain';
import { v4PublicApplicationPersonalPost$Json$Xml } from '../fn/public-personal-application/v-4-public-application-personal-post-json-xml';
import { V4PublicApplicationPersonalPost$Json$Xml$Params } from '../fn/public-personal-application/v-4-public-application-personal-post-json-xml';
import { v4PublicApplicationPersonalPost$Xml$Json } from '../fn/public-personal-application/v-4-public-application-personal-post-xml-json';
import { V4PublicApplicationPersonalPost$Xml$Json$Params } from '../fn/public-personal-application/v-4-public-application-personal-post-xml-json';
import { v4PublicApplicationPersonalPost$Xml$Plain } from '../fn/public-personal-application/v-4-public-application-personal-post-xml-plain';
import { V4PublicApplicationPersonalPost$Xml$Plain$Params } from '../fn/public-personal-application/v-4-public-application-personal-post-xml-plain';
import { v4PublicApplicationPersonalPost$Xml$Xml } from '../fn/public-personal-application/v-4-public-application-personal-post-xml-xml';
import { V4PublicApplicationPersonalPost$Xml$Xml$Params } from '../fn/public-personal-application/v-4-public-application-personal-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class PublicPersonalApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4PublicApplicationPersonalPingGet()` */
  static readonly V4PublicApplicationPersonalPingGetPath = '/v4/public/application/personal/ping';

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPingGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationPersonalPingGet$Plain$Response(params?: V4PublicApplicationPersonalPingGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemBooleanBaseResponse>> {
    return v4PublicApplicationPersonalPingGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPingGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationPersonalPingGet$Plain(params?: V4PublicApplicationPersonalPingGet$Plain$Params, context?: HttpContext): Observable<SystemBooleanBaseResponse> {
    return this.v4PublicApplicationPersonalPingGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemBooleanBaseResponse>): SystemBooleanBaseResponse => r.body)
    );
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPingGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationPersonalPingGet$Json$Response(params?: V4PublicApplicationPersonalPingGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemBooleanBaseResponse>> {
    return v4PublicApplicationPersonalPingGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPingGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationPersonalPingGet$Json(params?: V4PublicApplicationPersonalPingGet$Json$Params, context?: HttpContext): Observable<SystemBooleanBaseResponse> {
    return this.v4PublicApplicationPersonalPingGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemBooleanBaseResponse>): SystemBooleanBaseResponse => r.body)
    );
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPingGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationPersonalPingGet$Xml$Response(params?: V4PublicApplicationPersonalPingGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemBooleanBaseResponse>> {
    return v4PublicApplicationPersonalPingGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPingGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationPersonalPingGet$Xml(params?: V4PublicApplicationPersonalPingGet$Xml$Params, context?: HttpContext): Observable<SystemBooleanBaseResponse> {
    return this.v4PublicApplicationPersonalPingGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemBooleanBaseResponse>): SystemBooleanBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationPersonalPost()` */
  static readonly V4PublicApplicationPersonalPostPath = '/v4/public/application/personal';

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalPost$Json$Plain$Response(params?: V4PublicApplicationPersonalPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationPersonalPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalPost$Json$Plain(params?: V4PublicApplicationPersonalPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationPersonalPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalPost$Json$Json$Response(params?: V4PublicApplicationPersonalPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationPersonalPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalPost$Json$Json(params?: V4PublicApplicationPersonalPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationPersonalPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalPost$Json$Xml$Response(params?: V4PublicApplicationPersonalPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationPersonalPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalPost$Json$Xml(params?: V4PublicApplicationPersonalPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationPersonalPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationPersonalPost$Xml$Plain$Response(params?: V4PublicApplicationPersonalPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationPersonalPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationPersonalPost$Xml$Plain(params?: V4PublicApplicationPersonalPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationPersonalPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationPersonalPost$Xml$Json$Response(params?: V4PublicApplicationPersonalPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationPersonalPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationPersonalPost$Xml$Json(params?: V4PublicApplicationPersonalPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationPersonalPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationPersonalPost$Xml$Xml$Response(params?: V4PublicApplicationPersonalPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationPersonalPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationPersonalPost$Xml$Xml(params?: V4PublicApplicationPersonalPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationPersonalPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationPersonalApplicationIdPut()` */
  static readonly V4PublicApplicationPersonalApplicationIdPutPath = '/v4/public/application/personal/{applicationId}';

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalApplicationIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalApplicationIdPut$Plain$Response(params: V4PublicApplicationPersonalApplicationIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse>> {
    return v4PublicApplicationPersonalApplicationIdPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalApplicationIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalApplicationIdPut$Plain(params: V4PublicApplicationPersonalApplicationIdPut$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse> {
    return this.v4PublicApplicationPersonalApplicationIdPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse>): ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationPersonalApplicationIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalApplicationIdPut$Json$Response(params: V4PublicApplicationPersonalApplicationIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse>> {
    return v4PublicApplicationPersonalApplicationIdPut$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationPersonalApplicationIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationPersonalApplicationIdPut$Json(params: V4PublicApplicationPersonalApplicationIdPut$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse> {
    return this.v4PublicApplicationPersonalApplicationIdPut$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse>): ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse => r.body)
    );
  }

}
